export const CREDENTIALS_API_KEY = "ShopifyAuthApiKey"
export const CREDENTIALS_API_SECRET_KEY = "ShopifyAuthApiSecretKey"
export const CREDENTIALS_ACCESS_TOKEN = "ShopifyAuthSessionaccessToken"
export const CREDENTIALS_SESSION_SHOP = "ShopifyAuthSessionshop"
export const CREDENTIALS_SESSION_SCOPE = "ShopifyAuthSessionscope"
